import React from 'react'
import { Lozenge } from '@/atoms/Lozenge'
import { ParagraphSM, TitleXXS } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { ViewerDiscretionTooltip } from '@/views/TicketCheckoutViews/ShowtimesView/components/ShowtimeDetailsPanel/ViewerDiscretion/ViewerDiscretionTooltip'

export const ViewerDiscretion = () => {
  const { t } = useTranslate('tickets')
  const trigger = (
    <Lozenge
      size="sm"
      className="md:!photon-eyebrow-sm -mt-[9px] !bg-black/30 !text-white md:h-5 md:!rounded-[5px] md:!px-2.5 md:!py-1"
      variant="transparent"
    >
      {t('ages8AndUp', 'Ages 8+')}
    </Lozenge>
  )
  const content = (
    <>
      <TitleXXS color="core-gray-950" weight="medium">
        <Translate i18nKey="ages8AndUpAge" t={t}>
          <strong>Ages 8+</strong> (Guild Recommended Age)
        </Translate>
      </TitleXXS>
      <ParagraphSM className="mt-2 text-[0.688rem] leading-[16px]" color="core-gray-700">
        {t(
          'ages8discretion',
          'Contains scary chalk and crayon monsters and music, 1 sh*t, 5 h*ll, 2 dumb*ss, other mildly crude language.',
        )}
      </ParagraphSM>
    </>
  )
  return <ViewerDiscretionTooltip trigger={trigger} content={content} />
}
